export default __webpack_public_path__ + "static/O0311-58aaeb38ae9a45cac8e43552aa44006b.png";